/* eslint-disable sonarjs/no-hardcoded-passwords */
export const UserRoles = {
  // NOTE does not used ?
  GUEST: 1,
  REGISTERED: 2,
  ADMIN: 4,
};

export const UserConfig = {
  clientId: 'reaxys',
  clientSecret: 'reaxys',
  accessToken: 'access_token',
  tokenExpire: 'expires_in',
  refreshToken: 'refresh_token',
  scope: 'scope',
  tokenType: 'token_type',
  storage: 'user',
  key: 'info',
  expires: 1000 * 60 * 60 * 24 * 7,
  rememberAuth: false,
};

export const ProfileSettingsConfig = {
  FakePassword: '**********',
  Labels: {
    username: 'Username',
    email: 'Email',
    salutation: 'Title',
    firstName: 'First name',
    lastName: 'Last name',
    jobTitle: 'Job title',
    institution: 'Institute',
    location: 'Location',
    password: 'Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    preferences: 'Preferences',
    numberOfAtoms: '# of Atoms',
    numberOfFragmens: '# of Fragments',
    numberOfRingClosures: '# of Ring Closures',
    searchStructure: 'Search structure as',
    selectEditor: 'Structure Editor',
    defaultSettings: 'Default settings',
    lastStepOnly: 'Last Step only',
    numberOfPlansToCreate: 'Number of full routes to create',
    numberOfResultsPerPage: 'Number of results per page',
    maxAlternativeBranches: 'Max. alternative branches',
    maxNumberOfSteps: 'Max. number of steps',
    stereo: 'Stereo',
    regioSelectivity: 'Regioselectivity',
    stopSearchingIfStartingMaterialIsCommerciallyAvailable: 'Stop searching if building block is commercially available',
    defaultYieldForReactionsWithoutGivenYield: 'Default yield for reactions without a given yield',
    alwaysShowScreenBeforeCreatingAutoplan: 'Always show screen before creating autoplan',
    resultsPerPage: 'Results per page',
    textAndContrast: 'Text and Contrast',
    textSize: 'Text Size',
    textColor: 'Text Color',
    contrast: 'Contrast',
    supplierPreferences: 'Supplier preferences',
    preferredSuppliers: 'Preferred suppliers',
    defaultStructureOrReactionEditorSettings: 'Default structure/reaction editor settings',
    synthesisPlanner: 'Synthesis Planner',
    conditionsDisplayBehavior: 'Conditions/Examples display behavior',
    alwaysDisplayConditions: 'Always display conditions/examples',
    publishedDefaultSettings: 'Published Default Settings',
    predictionDefaultSettings: 'Predicted Default Settings',
    stepsWithIdenticalReaction: 'Steps with identical reaction',
    identicalBuildingBlocks: 'Identical building blocks',
    allowIdenticalReactionSteps: 'Allow identical reaction steps per project',
    allowIdenticalBuildingBlocks: 'Allow identical building blocks per project',
    processingTime: 'Processing time',
    usedBuildingBlocks: 'Used building blocks',
    showSynthesisPlannerParameters: 'Show synthesis planner parameters',
  },
  LinkText: {
    username: 'Add a username',
    email: 'Add an email',
    salutation: 'Add a title',
    firstName: 'Add a first name',
    lastName: 'Add a last name',
    jobTitle: 'Add a job title',
    institution: 'Add an institute',
    location: 'Add a location',
    password: 'Add a password',
    searchStructure: 'As drawn',
  },
};

export const RememberMeSettings = {
  token: 'remember_me_token',
  expires: 'remember_me_expires',
};
